<template>
  <!-- 学者列表 -->
  <div>
    <p class="total">找到{{ total }}条结果</p>
    <van-list
      v-model="loading"
      :finished="finished"
      :error="error"
      :finished-text="List.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="list-box" v-if="loading || List.length > 0">
        <BjItem
          class="list-item"
          v-for="item in List"
          :key="item.userId"
          :headerPhoto="item.logo"
          :name="item.title"
          :unit="item.unitName"
          :research="item.researchDirection"
          @click.native="toDetail(item.userId)"
        />
      </div>
      <noneList noneType="search" v-else />
    </van-list>
  </div>
</template>

<script>
import BjItem from "@/views/mobileView/components/listItem/bjItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  name: "Xz",
  components: { BjItem, noneList },
  data() {
    return {
      userPreferences: {
        pageNo: 0,
        pageSize: 20,
        queryParam: {
          configMap: {
            must: [
              {
                esField: "all",
                queryValue: this.$route.query.paramStr,
              },
              {
                esField: "type",
                queryValue: "2",
              },
            ],
          },
        },
      },
      List: [],
      total: 0,
      loading: false,
      finished: false,
      error: false,
    };
  },
  methods: {
    // 触底加载
    onLoad() {
      this.userPreferences.pageNo += 1;
      this.user();
    },
    // 搜索用户函数封装
    async user() {
      const resp = await this.$apis.searchServe.userList(this.userPreferences);
      if (resp.resultCode == 200) {
        this.List.push(...resp.data.list);
        this.finished = resp.data.list.length < 20;
        this.total = +resp.data.total;
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    // 学者跳转详情
    toDetail(id) {
      this.$router.push({
        path: "/appusesbaijia",
        query: {
          item: 0,
          id,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.total {
  text-align: center;
  font-size: 13px;
  color: #999999;
  line-height: 19px;
}
.list-box {
  .list-item {
    margin-top: 15px;
    padding: 12px;
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;
  }
}
</style>
